import React from 'react';
import { Image } from '@blueprint/image';
import { useNewHomesDevelopmentDetailsSummaryQuery } from '../DevelopmentDetailsSummary.generated';
import SummaryHeader from '../SummaryHeader/SummaryHeader';
import { Images } from './Summary.styles';
import DevelopmentOptions from '../DevelopmentOptions/DevelopmentOptions';

const Summary: React.FC<{ developmentId: number; ddpLink: string | null }> = ({
    developmentId,
    ddpLink
}) => {
    const { data, loading } = useNewHomesDevelopmentDetailsSummaryQuery({
        variables: { id: developmentId, deprecatedBranchId: developmentId }
    });

    const name = data?.newHomesDevelopmentData?.name;
    const developerName = data?.newHomesDevelopmentData?.developer?.name;
    const logoUri = data?.newHomesDevelopmentData?.logoUri;
    const images = data?.newHomesDevelopmentData?.images || [];
    const bedrooms = data?.newHomesDevelopmentData?.bedrooms;
    const helpToBuy = data?.newHomesDevelopmentData?.helpToBuy;
    const sharedOwnership = data?.newHomesDevelopmentData?.sharedOwnership;
    const minimumPlotPrice = data?.newHomesDevelopmentData?.minimumPlotPrice;
    const hasOnlyPriceOnAsk =
        data?.newHomesDevelopmentData?.listingsDetails?.hasOnlyPriceOnAsk;
    const listings =
        data?.newHomesDevelopmentData?.listingsDetails?.listings || [];

    return (
        <>
            {loading && <p>is loading</p>}
            {!loading && !data?.newHomesDevelopmentData && <p>no data</p>}

            <SummaryHeader
                name={name}
                ddpLink={ddpLink}
                developerName={developerName}
                logoUri={logoUri}
            />

            {!!images.length && (
                <Images imageCount={images.length}>
                    {images.map((img, idx) => (
                        <Image
                            src={img || ''}
                            alt={`${name} development image ${idx}`}
                            key={`image-${idx}`}
                            lazy
                            data-testid="listing-image"
                        />
                    ))}
                </Images>
            )}

            <DevelopmentOptions
                bedrooms={bedrooms}
                helpToBuy={helpToBuy}
                sharedOwnership={sharedOwnership}
                minimumPlotPrice={minimumPlotPrice}
                hasOnlyPriceOnAsk={hasOnlyPriceOnAsk}
                listings={listings}
            />
        </>
    );
};

export default Summary;
